import { LOGO_URL } from "../utils/constants";
import { useState, useContext } from "react";
import { Link } from "react-router";
import UserContext from "../utils/UserContext";
import { useSelector } from "react-redux";
const Header = () => {
    const cartItems = useSelector((store) => store.cart.items);
    const data = useContext(UserContext);
    const [btnName, setBtnName] = useState("Login");
    const handleLoginBtn = () => {
        if (btnName === "Login") {
            setBtnName("Logout");
        } else {
            setBtnName("Login");
        }
    };

    return (
        <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
            <div className="flex justify-between items-center px-8 py-3">
                <div>
                    <img className="w-14 h-14 object-contain" src={LOGO_URL} alt="Logo" />
                </div>
                <ul className="flex items-center gap-6 list-none m-0 p-0">
                    <li>
                        <Link
                            to="/"
                            className="text-gray-600 font-medium hover:text-orange-500 transition-colors text-sm"
                        >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/about"
                            className="text-gray-600 font-medium hover:text-orange-500 transition-colors text-sm"
                        >
                            About
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/contact"
                            className="text-gray-600 font-medium hover:text-orange-500 transition-colors text-sm"
                        >
                            Contact
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/cart"
                            className="flex items-center gap-1 text-gray-700 font-semibold hover:text-orange-500 transition-colors text-sm"
                        >
                            🛒 Cart ({cartItems.length})
                        </Link>
                    </li>
                    <li>
                        <button
                            className="px-5 py-1.5 bg-orange-500 text-white text-sm font-bold rounded-full hover:bg-orange-600 active:scale-95 transition-all"
                            onClick={handleLoginBtn}
                        >
                            {btnName}
                        </button>
                    </li>
                    {data.defaultUser && (
                        <li className="px-4 py-1.5 bg-gray-100 rounded-full text-sm font-semibold text-gray-700 max-w-[120px] truncate">
                            {data.defaultUser}
                        </li>
                    )}
                </ul>
            </div>
        </header>
    );
};

export default Header;
